<template>
  <span v-tooltip:top="tooltip">
    <!-- eslint-disable-next-line vue/no-v-html vue/no-v-text-v-html-on-component -->
    <WdsText v-if="html" v-html="html" />
    <WdsText v-else :strike-through="strikeThrough">{{ text }}</WdsText>
  </span>
</template>

<script>
import { WdsText } from '@worksome/wds-components'

export default {
  components: {
    WdsText,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    html: {
      type: [String, Number],
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    strikeThrough: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
